import { randomId } from './randomId.js';

export const bindPusherConnectionTelemetry = ({ connection, emit }) => {
  try {
    if (!connection || typeof connection.bind !== 'function' || typeof emit !== 'function') {
      return;
    }

    const clientInstanceId = randomId(16, 'all');
    let socketId = '';

    const emitSafely = (event) => {
      try {
        const pendingEvent = emit({ ...event, clientInstanceId });
        Promise.resolve(pendingEvent).catch(() => undefined);
      } catch {}
    };

    connection.bind('connected', () => {
      try {
        socketId = typeof connection.socket_id === 'string' ? connection.socket_id : '';
        emitSafely({
          eventType: 'connected',
          socketId,
          previousState: '',
          connectionState: 'connected',
          errorCode: '',
          error: ''
        });
      } catch {}
    });

    connection.bind('state_change', (states) => {
      try {
        const previousState = typeof states?.previous === 'string' ? states.previous : '';
        const currentState = typeof states?.current === 'string' ? states.current : '';

        if (previousState !== 'connected' || !currentState || currentState === 'connected') {
          return;
        }

        emitSafely({
          eventType: 'disconnected',
          socketId,
          previousState,
          connectionState: currentState,
          errorCode: '',
          error: ''
        });
        socketId = '';
      } catch {}
    });

    connection.bind('error', (error) => {
      try {
        const rawCode = error?.data?.code ?? error?.code ?? error?.type ?? '';
        const rawMessage = error?.data?.message ?? error?.message ?? '';
        const errorCode = typeof rawCode === 'string' || typeof rawCode === 'number' ? String(rawCode).slice(0, 64) : '';
        const errorMessage = typeof rawMessage === 'string' || typeof rawMessage === 'number' ? String(rawMessage).slice(0, 500) : '';

        emitSafely({
          eventType: 'error',
          socketId,
          previousState: '',
          connectionState: typeof connection.state === 'string' ? connection.state : '',
          errorCode,
          error: errorMessage
        });
      } catch {}
    });
  } catch {}
};
